import React, { useState } from "react";
import "./Header.scss";
import NCLOGO from "./Logo.png";
import { IoIosArrowDown } from "react-icons/io";
import { IoMdMenu } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
// import { FaCaretDown } from "react-icons/fa";
const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [ShowTooltip, setShowTooltip] = useState();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const isActive = (path) => location.pathname.includes(path);
  return (
    <>
      <div className="Home-Header-Maindiv">
        <div className="dflex alignitems JSBetween Logos">
          <img src={NCLOGO} alt="NCLLogo" className="LOGO" />

          <div className="HMenu dflex alignitems gap-3 ">
            <span onClick={() => navigate("/")}>Home</span>
            {/* className={isActive("/") && "Web-Header-Active"} */}
            <span
              // className={isActive("/AboutUs") && "Web-Header-Active"}
                style={{ position: "relative" }}
              onMouseEnter={() => setShowTooltip("AboutUs")}
              onMouseLeave={() => setShowTooltip()}
            > About Us <IoIosArrowDown />
              {ShowTooltip === "AboutUs" && (
                <div className="Card dflex flexd-column SubMenu p-0">
                 <span onClick={() => navigate("/Founder")}> Founder </span>
                  <span onClick={() => navigate("/AboutUs")} > What We Do </span>
                  <span onClick={() => navigate("/Coreteam")} >Core Team </span>
                </div>
              )}
            </span>
            <span
              onClick={() => navigate("/Our Board")}
              className={isActive("/Our%20Board") && "Web-Header-Active"}
            >
              {" "}
              Our Board{" "}
            </span>
            <span
              onClick={() => navigate("/Publications")}
              className={isActive("/Publications") && "Web-Header-Active"}
            >
              {" "}
              Publications{" "}
            </span>
            <span
              style={{ position: "relative" }}
              onMouseEnter={() => setShowTooltip("Publications")}
              onMouseLeave={() => setShowTooltip()}
            >
              {" "}
              Programs <IoIosArrowDown />
              {ShowTooltip === "Publications" && (
                <div className="Card dflex flexd-column SubMenu p-0">
                  <span
                    onClick={() =>
                      window.open("https://ncp.northsouth.org/", "_blank")
                    }
                  >
                    {" "}
                    Assessments (NCP){" "}
                  </span>
                  <span
                    onClick={() =>
                      window.open("https://nsp.northsouth.org/", "_blank")
                    }
                  >
                    {" "}
                    Scholarships (NSP){" "}
                  </span>
                </div>
              )}
            </span>
            <span
              onClick={() => navigate("/Contact Us")}
              className={isActive("/Contact%20Us") && "Web-Header-Active"}
            >
              {" "}
              Contact Us{" "}
            </span>
          </div>

          <div className="NSF-SItes dflex gap-3">
            <span
              onClick={() =>
                window.open("https://www.northsouth.org/", "_blank")
              }
            >
              {" "}
              NorthSouth USA{" "}
            </span>
            {/* <span  > NSF Scholarship </span> */}
            {/* onClick={() => window.open("https://india.northsouth.org/", "_blank")} */}
          </div>
          <div className="dflex alignitems">
            <div className=" dflex gap-3 DL_Buttons">
              <button
                className="Website-Buttons" 
                onClick={() => navigate("/Donate")}
              >
                {" "}
                Donate{" "}
              </button>
              <span
                style={{ position: "relative" }}
                onMouseEnter={() => setShowTooltip("Login")}
                onMouseLeave={() => setShowTooltip()}
              >
                <button className="Website-Buttons">
                  {" "}
                  Log in <IoIosArrowDown />{" "}
                </button>
                {ShowTooltip === "Login" && (
                  <div className="Card dflex flexd-column Login-SubMenu p-0">
                    <span
                      onClick={() =>
                        window.open(
                          "https://portal.northsouth.org/app6/MainTest.aspx?_gl=1*1s55zv0*_ga*MzU0MjY2NjQzLjE3NDcyMTcxOTg.*_ga_NFGY5F210T*czE3NzM3NDEwNTYkbzkwJGcwJHQxNzczNzQxMDU2JGo2MCRsMCRoOTYwNzkzOTI4",
                          "_blank",
                        )
                      }
                    >
                      NSF Scholarships{" "}
                    </span>
                    <span
                      onClick={() =>
                        window.open(
                          "https://ncl.northsouth.org/Login/",
                          "_blank",
                        )
                      }
                    >
                      NCP Assessments{" "}
                    </span>
                  </div>
                )}
              </span>
            </div>
            <button className="menu-toggle" onClick={toggleMenu}>
              {" "}
              <IoMdMenu />{" "}
            </button>
          </div>
        </div>
      </div>
      <div className={`sidebar ${isMenuOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={toggleMenu}>
          <IoMdClose />{" "}
        </button>
        <div
          className="dflex flexd-column gap-3 "
          style={{ alignItems: "flex-start" }}
        >
          <span onClick={() => navigate("/")}>Home</span>
          <span 
          style={{ position: "relative" }}
           onClick={() =>
              setShowTooltip(
                ShowTooltip === "AboutUs" ? "" : "AboutUs",
              )
            }
              // onMouseEnter={() => setShowTooltip("AboutUs")}
              // onMouseLeave={() => setShowTooltip()}
          > About Us <IoIosArrowDown />

            {ShowTooltip === "AboutUs" && (
                <div className="Card dflex flexd-column SubMenu p-0">
                  <span onClick={() => navigate("/Founder")}> Founder </span>
                  <span onClick={() => navigate("/AboutUs")} > What We Do </span>
                  <span onClick={() => navigate("/Coreteam")} >Core Team </span>
                </div>
              )}
          </span>
          <span onClick={() => navigate("/Our Board")}> Our Board </span>
          <span onClick={() => navigate("/Publications")}> Publications </span>
          <span
            style={{ position: "relative" }}
            onClick={() =>
              setShowTooltip(
                ShowTooltip === "Publications" ? "" : "Publications",
              )
            }
          >
            Programs <IoIosArrowDown />
            {ShowTooltip === "Publications" && (
              <div className="Card dflex flexd-column SubMenu mt-1">
                <span
                  onClick={() =>
                    window.open("https://ncp.northsouth.org/", "_blank")
                  }
                >
                  {" "}
                  Assessments (NCP){" "}
                </span>
                <span
                  onClick={() =>
                    window.open("https://nsp.northsouth.org/", "_blank")
                  }
                >
                  {" "}
                  Scholarships (NSP)
                </span>
              </div>
            )}
          </span>
          <span onClick={() => navigate("/Contact Us")}> Contact Us </span>

          <div className="Side_NSF-SItes dflex gap-3 flexd-column w-100">
            <span
              onClick={() =>
                window.open("https://www.northsouth.org/", "_blank")
              }
            >
              {" "}
              NorthSouth USA{" "}
            </span>
            {/* <span > NSF Scholarship </span> */}
          </div>
          <div className=" dflex gap-3 Side_DL_Buttons flexd-column w-100">
            <button
              className="Website-Buttons "
              onClick={() => navigate("/Donate")}
            >
              {" "}
              Donate{" "}
            </button>
            <span
              style={{ position: "relative" }}
              onMouseEnter={() => setShowTooltip("Login")}
              onMouseLeave={() => setShowTooltip()}
            >
              <button className="Website-Buttons w-100">
                {" "}
                Log in <IoIosArrowDown />{" "}
              </button>
              {ShowTooltip === "Login" && (
                <div className="Card dflex flexd-column Login-SubMenu p-0">
                  <span> NSF Scholarships </span>
                  <span
                    onClick={() =>
                      window.open("https://ncl.northsouth.org/", "_blank")
                    }
                  >
                    NCP Assessments{" "}
                  </span>
                </div>
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default Header;
